import React, { useEffect, useState } from 'react';
import * as Styled from './styles';
import Navbar from 'react-bootstrap/Navbar';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import { classEnum, imageUrls, actiontype } from '../../utils/constants';
import { BLUR_DATA_URL } from '../../views/homepage/constants';
import { ShouldRender } from 'should-render';
import { useRouter } from 'next/router';
import { useWallet } from '../../../context/WalletContext';
import { TopNavbarLinks } from '../../components/common/TopNavbar/TopNavbarLinks';
import NavbarDropdownButton from '../../components/common/TopNavbar/NavbarDropdown';
import MagicWithdrawal from './MagicWithdrawal';
import WalletDetails from '../Wallet';
import { useApp } from '../../../context/AppContext';
import {
  fetchBNBBalance,
  getBalanceFromAddr,
  getMagicBnBWeb3Provider,
} from '../../utils/wallet';
import { WalletOption } from '../../../context/AppContext/types';
import { useDeviceDetect } from '../../hooks/useDeviceDetect';
import { useConnectWallet } from 'src/hooks/useConnectWallet';
import clsx from 'clsx';

const Footer = dynamic(() => import('../../components/common/Footer'));

const TopNavBarCommon = () => {
  const {
    state: {
      wallet: {
        account,
        metamaskProvider,
        balanceAlgo,
        balanceZone,
        afkelephants,
        profilePictureInfo,
        blockChain,
      },
    },
    dispatch,
  } = useApp();
  const {
    state: { walletManager },
  } = useWallet();
  const { isMobile } = useDeviceDetect();
  const { connectWallet } = useConnectWallet();
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [showWallet, setShowWallet] = useState(false);

  useEffect(() => {
    if (account) {
      setShowWallet(true);
      setOpen(false);
    }
  }, [account]);

  const handleConnect = () => {
    setOpen(true);
  };

  const updateWalletBalance = async (account: string) => {
    const type: any = localStorage.getItem('walletManagerType');
    if (type === WalletOption.MAGIC && blockChain === 'BINANCE') {
      const provider = metamaskProvider;
      const {
        bnbBalance = 0,
        USDCBalance = 0,
        FLOKIBalance = 0,
        DOGEBalance = 0,
        BTCBBalance = 0,
        ETHBalance = 0,
        BUSDBalance = 0,
        USDTBalance = 0,
      } = (await fetchBNBBalance(account, provider)) || {};
      dispatch({
        type: actiontype.SET_WALLET_BALANCE,
        payload: {
          balanceAlgo,
          balanceZone,
          minAlgoBalance: 0,
          gAlgoBalance: 0,
          algoStkBalance: 0,
          deflyBalance: 0,
          pepeBalance: 0,
          USDCBalance,
          balanceBNB: bnbBalance,
          FLOKIBalance,
          DOGEBalance,
          BTCBBalance,
          ETHBalance,
          BUSDBalance,
          USDTBalance,
        },
      });
    } else {
      const {
        balanceZone,
        balanceAlgo,
        gAlgoBalance,
        algoStkBalance,
        deflyBalance,
        pepeBalance,
        USDCBalance,
        isOptedIn,
        isGALGOOptedIn,
        isAlgoStakeOptedIn,
        isDeflyOptedIn,
        isPepeOptedIn,
        isUSDCOptedIn,
        isCoopOptedIn,
        CoopBalance,
        minAlgoBalance,
        isMetaOptedIn,
        MetaBalance,
      } = await getBalanceFromAddr(account);

      dispatch({
        type: actiontype.SET_WALLET_BALANCE,
        payload: {
          balanceAlgo,
          balanceZone,
          gAlgoBalance,
          balanceBNB: 0,
          algoStkBalance,
          deflyBalance,
          pepeBalance,
          USDCBalance,
          CoopBalance,
          MetaBalance,
          minAlgoBalance,
        },
      });
      dispatch({
        type: actiontype.SET_OPTIN,
        payload: {
          isOptedIn,
          isGALGOOptedIn,
          isAlgoStakeOptedIn,
          isDeflyOptedIn,
          isPepeOptedIn,
          isUSDCOptedIn,
          isCoopOptedIn,
          isMetaOptedIn,
        },
      });
    }
  };
  const walletBalanceFunc = async () => {
    const type: any = localStorage.getItem('walletManagerType') || '';
    const blockChain = localStorage.getItem('blockChain');
    const walletAddress: any = localStorage.getItem('walletAddress');

    //@ts-ignore
    if (blockChain === 'BINANCE' && walletAddress) {
      const bnbProvider = await getMagicBnBWeb3Provider();
      connectWallet(type, walletAddress, {}, bnbProvider, blockChain);
    } else {
      walletAddress && connectWallet(type, walletAddress, {}, null);
    }
  };

  useEffect(() => {
    if (!account) {
      walletBalanceFunc();
    }
  }, [account]);
  useEffect(() => {
    if (account && window?.navigator?.onLine) {
      updateWalletBalance(account);
    }
  }, [account]);

  return (
    <div
      style={{
        background: '#0b0c0b',
        minHeight: '100%',
      }}
      className="h-100 w-100"
    >
      <div className="h-100 w-100">
        <div style={{ height: '100px' }}>
          <Styled.NavbarContainer expand="lg">
            <Styled.Root>
              <div className="d-flex align-items-center justify-content-start">
                <Navbar.Toggle
                  aria-controls="basic-navbar-nav"
                  // className="d-md-none d-flex"
                  // WHEN SHOWING THIS TOGGLE BUTTON, UN COMMENT THE MobileNavBarToggle INSTANCE
                  className="d-md-none d-none"
                  // onClick={toggleIsOpen}
                />
                <Styled.NavLogoWrapper>
                  <Image
                    onClick={() => router.replace('/')}
                    src={imageUrls.logo}
                    width={77}
                    height={50}
                    alt="zone"
                    blurDataURL={BLUR_DATA_URL}
                  />
                </Styled.NavLogoWrapper>
                <TopNavbarLinks isChatSidebarOpen={false} hideStake={true} />
              </div>
              <div className="flex">
                <ShouldRender if={!account}>
                  <Styled.NavbarButton onClick={handleConnect}>
                    Connect
                  </Styled.NavbarButton>
                </ShouldRender>
                <ShouldRender if={account}>
                  <NavbarDropdownButton
                    isWithdrawal
                    account={account}
                    dispatch={dispatch}
                    walletManager={walletManager}
                    blockChain={blockChain}
                    afkelephants={afkelephants}
                    router={router}
                    showWalletOption={false}
                    profilePictureInfo={profilePictureInfo}
                  />
                </ShouldRender>
              </div>
            </Styled.Root>
          </Styled.NavbarContainer>
        </div>
        {!showWallet ? (
          <Styled.WithdrawContainer
            className={clsx(
              'd-flex align-items-center',
              isMobile && 'flex-column-reverse',
            )}
          >
            <div
              className="text-white w-30"
              style={{ padding: isMobile ? '20px' : '20px 120px' }}
            >
              <div
                style={{
                  fontSize: '40px',
                  fontWeight: '700',
                  fontFamily: 'Aeonik',
                }}
              >
                Withdraw funds from your Magic Wallet!
              </div>
              <div
                style={{
                  marginTop: '16px',
                  marginBottom: '16px',
                  fontSize: '16px',
                  fontWeight: '400',
                  fontFamily: 'Aeonik',
                }}
              >
                Please make sure to connect the right email to access your
                wallet & transfer your funds securely.
              </div>
              <div style={{ alignSelf: 'flex-start' }}>
                <Styled.NavbarButton
                  className={classEnum.buttonYellow}
                  onClick={handleConnect}
                >
                  Connect
                </Styled.NavbarButton>
              </div>
            </div>
            <div className={clsx('w-70')}>
              <Image
                src={imageUrls.WithDrawalImg}
                alt="alt"
                height={isMobile ? 300 : 530}
                width={isMobile ? 500 : 800}
              />
            </div>
          </Styled.WithdrawContainer>
        ) : (
          <Styled.WalletDetailContainer>
            <div className="container flex-1">
              <WalletDetails />
            </div>
          </Styled.WalletDetailContainer>
        )}
        <Footer />
      </div>
      {open && (
        <MagicWithdrawal
          setShowWallet={setShowWallet}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default TopNavBarCommon;
